import Text from 'components/Text/Text';
import {
	IPushesViewContext,
	PushesViewContext,
} from '../../../../../../../pushesViewContext/pushesViewState/pushesViewContext';
import React, { useContext } from 'react';
import style from './DropdownMenu.module.scss';

const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IPushesViewContext>(PushesViewContext);

	return (
		<div className={style.container}>
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="form" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text translationNameSpace="form" translationKey="sortByNameLabel" theme="neutralLight" size="s" />
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByName1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Name1-10')}
						checked={sortBy === 'Name1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByName10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('Name10-1')}
						checked={sortBy === 'Name10-1'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByLastUpdateLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByLastUpdate1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('LastUpdate1-10')}
						checked={sortBy === 'LastUpdate1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByLastUpdate10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('LastUpdate10-1')}
						checked={sortBy === 'LastUpdate10-1'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByUpdatedByLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByUpdatedByA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('UpdatedByA-Z')}
						checked={sortBy === 'UpdatedByA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByUpdatedByZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('UpdatedByZ-A')}
						checked={sortBy === 'UpdatedByZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortBySoftwareTypeLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortBySoftwareTypeA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('SoftwareTypeA-Z')}
						checked={sortBy === 'SoftwareTypeA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortBySoftwareTypeZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('SoftwareTypeZ-A')}
						checked={sortBy === 'SoftwareTypeZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default DropdownMenu;
